import React from "react";
import RedirectButtonComponentPresentation from "./ScannerBottomButtonBarPresentation";
import { TaskType } from "@coworker/apprestructured/src/tasks/enums/taskTypes";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import {
  getCurrentScannerIndex,
  handleScannerRedirectClick,
  ScannerType,
  ScannerTypeEnum,
} from "./scannerBottomButtonBarUtils";
import { isAnyRDT } from "@coworker/reusable/helpers/devices";
import { useTranslation } from "@coworker/locales";

interface RedirectButtonProps {
  typeOfScanner: ScannerType;
  taskType: TaskType;
}

const ScannerBottomButtonBar: React.FC<RedirectButtonProps> = ({
  typeOfScanner,
  taskType,
}) => {
  const navigate = useFixaNavigate();
  const { t } = useTranslation();
  const shouldShowRedirectButton = isAnyRDT();
  if (!shouldShowRedirectButton) return null;

  const navigateTo = (index: ScannerTypeEnum) => {
    handleScannerRedirectClick(typeOfScanner, taskType, index, navigate);
  };

  const currentScannerIndex = getCurrentScannerIndex(typeOfScanner);
  const labels = [
    { label: t("laserScanString") },
    { label: t("cameraScanString") },
  ];

  return (
    <RedirectButtonComponentPresentation
      activeScannerIndex={currentScannerIndex}
      navigate={navigateTo}
      items={labels}
    />
  );
};

export default ScannerBottomButtonBar;
